import React from 'react';
import ChatThread from '../../../shared/chat/ChatThread';

type Props = {
  threadMessages?: any[];
  customerName: string;
};

const ThreadSection: React.FC<Props> = ({ threadMessages, customerName }) => {
  if (!Array.isArray(threadMessages) || threadMessages.length === 0) {
    return <div className="text-sm text-gray-500 text-center py-4">No thread available. Open full signal to view.</div>;
  }
  return (
    <ChatThread messages={threadMessages} customerName={customerName} showMeta={true} />
  );
};

export default React.memo(ThreadSection);
